import createReducer from "./../createReducer";
import { handlersConfigs } from "./handlers";
import { settingsInitials } from "../../helpers/dataManipulations/initials";

export default createReducer(settingsInitials, handlersConfigs);
